/**
 * @license
 * Copyright Endlessjs. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

import { NgModule } from '@angular/core';

import { ElSharedModule } from '../shared/shared.module';
import { ElIconModule } from '../icon/icon.module';
import {
  ElCardComponent,
  ElCardBodyComponent,
  ElCardFooterComponent,
  ElCardHeaderComponent,
} from './card.component';

import { ElRevealCardComponent } from './reveal-card/reveal-card.component';
import { ElFlipCardComponent } from './flip-card/flip-card.component';
import { ElCardFrontComponent, ElCardBackComponent } from './shared/shared.component';

const EL_CARD_COMPONENTS = [
  ElCardComponent,
  ElCardBodyComponent,
  ElCardFooterComponent,
  ElCardHeaderComponent,
  ElRevealCardComponent,
  ElFlipCardComponent,
  ElCardFrontComponent,
  ElCardBackComponent,
];

@NgModule({
  imports: [
    ElSharedModule,
    ElIconModule,
  ],
  declarations: [
    ...EL_CARD_COMPONENTS,
  ],
  exports: [
    ...EL_CARD_COMPONENTS,
  ],
})
export class ElCardModule { }
